import {en} from './en';
import {pl} from './pl';

export const texts = {
	en: en,
	pl: pl
};
